module.exports = __webpack_public_path__ + "1a25892e25b71e9d232ec896b590663f.svg";